import { render, staticRenderFns } from "./Zyzbody.vue?vue&type=template&id=cfb1cb88&scoped=true&"
import script from "./Zyzbody.vue?vue&type=script&lang=js&"
export * from "./Zyzbody.vue?vue&type=script&lang=js&"
import style0 from "./Zyzbody.vue?vue&type=style&index=0&id=cfb1cb88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb1cb88",
  null
  
)

export default component.exports